import { render, staticRenderFns } from "./mySubmitted.vue?vue&type=template&id=5bc05b88&scoped=true&"
import script from "./mySubmitted.vue?vue&type=script&lang=js&"
export * from "./mySubmitted.vue?vue&type=script&lang=js&"
import style0 from "./mySubmitted.vue?vue&type=style&index=0&id=5bc05b88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc05b88",
  null
  
)

export default component.exports